import { GetAllRolesQuery, GetAllRolesQuery_getAllRoles } from '@generated/GetAllRolesQuery';
import { GET_ALL_ROLES_QUERY } from '@graphql/queries/GetAllRolesQuery';
import { useGraphQuery } from '@hooks/useQuery';

interface UseCompanyRolesReturnType {
  companyRoles: GetAllRolesQuery_getAllRoles[];
  loading: boolean;
}

export const useCompanyRoles = (): UseCompanyRolesReturnType => {
  const { data: companyRolesData, loading } = useGraphQuery<GetAllRolesQuery>(GET_ALL_ROLES_QUERY);

  return { companyRoles: companyRolesData?.getAllRoles || [], loading };
};
